const AppDiscovery = require('./active/appdiscovery.svg');
const AppDiscoveryInactive = require('./inactive/appdiscovery.svg');
const Max = require('./active/max.svg');
const MaxInactive = require('./inactive/max.svg');
const SafeDK = require('./active/safedk.png');
const SafeDKInactive = require('./inactive/safedk.png');
export { AppDiscovery, AppDiscoveryInactive, Max, MaxInactive, SafeDK, SafeDKInactive };
//# sourceMappingURL=index.js.map